import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import NodalTxnRemarksModalUI from './NodalTxnRemarksModalUI.js'

class NodalTxnRemarksModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      remarks: this.props.selectedRemarks || '',
      remarksError: null,
      nodalExtTxnType: null
    }
  }

  render() {
    return (
      <NodalTxnRemarksModalUI
        context={this.props.context}
        accountNumber={this.props.accountNumber}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        remarks={this.state.remarks}
        onRemarksChange={(event) => { this.setState({ remarks: event.target.value }) }}
        remarksError={this.state.remarksError}
        setRemarksError={(error) => { this.setState({ remarksError: error }) }}
        //
        nodalExtTxnType={this.state.nodalExtTxnType}
        onNodalExtTxnTypeChange={(event) => { this.setState({ nodalExtTxnType: event.target.value }) }}
        nodalExtTxnTypeError={this.state.nodalExtTxnTypeError}
        setNodalExtTxnTypeError={(error) => { this.setState({ nodalExtTxnTypeError: error }) }}
        nodalExtTxnTypeList={this.props.nodalExtTxnTypeList}
        //
        reconciliationStatus={this.props.reconciliationStatus}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    // console.log(this.props)
    if (prevProps.selectedRemarks != this.props.selectedRemarks)
      this.setState({ remarks: this.props.selectedRemarks })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/nodalBankAccounts/${this.props.accountNumber}/bankTransactions/${this.props.transactionId}/nodalExtTxnType`,
      this.onSubmitCallback, {
        remarks: this.state.remarks,
        externalTxnType: this.state.nodalExtTxnType
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 500)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default NodalTxnRemarksModalSF
